export default __webpack_public_path__ + "static/module-cards-401a9f069de2ba88b34bee2dc8ce2fa3.png";